import { FC } from 'react';

import { Dialog } from '@mui/material';

import styles from './MaxmizeImagesDialogWrapper.module.scss';

type Props = {
  open: boolean;
  onClose: () => void;
  previewImage: string;
};

const MaxmizeImagesDialogWrapper: FC<Props> = ({ open, onClose, previewImage }) => {
  return (
    <Dialog
      onClose={() => onClose()}
      open={open}
      fullWidth={true}
      maxWidth={'lg'}
      PaperProps={{
        style: {
          backgroundColor: 'transparent',
          boxShadow: 'none',
          maxWidth: '1200px',
        },
      }}
      BackdropProps={{
        classes: {
          root: styles.backDrop,
        },
      }}
    >
      <div className={styles.container}>
        <div className={styles.image_container}>
          <img src={`${previewImage}`} alt="承認依頼写真" />
        </div>
      </div>
    </Dialog>
  );
};

export default MaxmizeImagesDialogWrapper;
